import * as api from '@dynameat/api';
import * as MutationTypes from '@dynameat/mutationTypes';
import { Group } from '../models';

export const groupTypeListRequest = async ({ commit, getters: { groupList } }) => {
  if (groupList.length === 0) {
    const response = await api.groupTypeListRequest();
    const groups = Group.toInstanceList(response.data);
    commit(MutationTypes.GROUP_TYPE_LIST_SUCCESS, groups);
    return groups;
  }
  return groupList;
};
